import { Component, ElementRef, EventEmitter, Input, Output, ViewChild, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

import { TituloReceberSituacao, tituloReceberSituacoes } from '../titulo-receber-situacao';

@Component({
    selector: 'sgt-titulo-receber-situacao-select',
    templateUrl: './titulo-receber-situacao-select.component.html',
    styleUrls: ['./titulo-receber-situacao-select.component.less'],
    providers: [
        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => TituloReceberSituacaoSelectComponent), multi: true },
    ]
})
export class TituloReceberSituacaoSelectComponent {
    /** ID da situação do título a rececer */
    @Input() ngModel: number;
    /** Ao alterar a situação do título a receber */
    @Output() ngModelChange = new EventEmitter<number>();

    /** Situação do título a receber */
    @Input() situacao: TituloReceberSituacao;
    @Output() situacaoChange = new EventEmitter<TituloReceberSituacao>();

    /** Situações dos títulos a receber */
    situacoes = tituloReceberSituacoes;

    /** Nome do input */
    @Input() name: string;
    /* ID do input */
    @Input() id: string;
    /* Se o valor é obrigatório */
    @Input() required: any;
    /* Se deve desabilitar o input */
    @Input() disabled: boolean;
    /** Se deve setar o focus automaticamente */
    @Input() autofocus = false;
    /** Se pode selecionar nenhuma opção */
    @Input() canSelectNull = true;

    @ViewChild('select') select: ElementRef;

    propagateChange: any = () => {};

    /** Ao alterar a situação do título a receber */
    onChange(id: number) {
        this.ngModel = id;
        this.ngModelChange.emit(this.ngModel);
        this.propagateChange(this.ngModel);

        this.situacao = this.situacoes?.find(situacaoFilter => situacaoFilter.id === id);
        this.situacaoChange.emit(this.situacao);
    }

    /** Seta o focus no select */
    setFocus() {
        jQuery(this.select?.nativeElement).trigger('focus');
    }

    writeValue(value: number) {}

    registerOnChange(fn) {
        this.propagateChange = fn;
    }

    registerOnTouched() {}
}
